import { Navigate, Route, Routes } from "react-router-dom";
import ResourcesPage from "../../presentation/pages/ResourcesPage";
import ResourceDetailPage from "../../presentation/pages/ResourceDetailPage";
import { ROUTES } from "../../shared/constants/routes";

const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to={ROUTES.RESOURCES} replace />} />
      <Route path={ROUTES.RESOURCES} element={<ResourcesPage />} />
      <Route
        path={`${ROUTES.RESOURCES}/:slug`}
        element={<ResourceDetailPage />}
      />
      <Route path="*" element={<Navigate to={ROUTES.RESOURCES} replace />} />
    </Routes>
  );
};

export default AppRouter;
